// extracted by mini-css-extract-plugin
module.exports = {"imgHolder":"styles_img-holder__OqcRX","lottieHolder":"styles_lottie-holder__3dmzl","hide":"styles_hide__MVQC_"};